import { Component } from '@angular/core';

@Component({
  selector: 'app-attendance-landing-page',
  templateUrl: './attendance-landing-page.component.html',
  styleUrls: ['./attendance-landing-page.component.scss']
})
export class AttendanceLandingPageComponent {

}
